import React, { useState } from 'react';

import MappedEventQuickLook, { IMappedEventQuickLook } from './MappedEventQuickLook';
import RawEventQuickLook, { IRawEventQuickLook } from './RawEventQuickLook';
import { Popover, PopoverProps } from 'antd';

export interface IQuickLook extends IRawEventQuickLook, IMappedEventQuickLook {
  type?: 'mapped_event' | 'raw_event';
}

const QuickLook: React.FC<IQuickLook> = ({ type, id, name, ...commonRestProps }) => {
  if (type === 'raw_event') {
    return <RawEventQuickLook id={id} name={name} {...commonRestProps} />;
  }
  return <MappedEventQuickLook id={id} {...commonRestProps} />;
};

export interface IPopoverQuickLook {
  quickLookProps?: IQuickLook;
  popoverProps?: PopoverProps;
}

export const PopoverQuickLook: React.FC<IPopoverQuickLook> = ({
  quickLookProps = {},
  popoverProps = {},
  children,
}) => {
  const { okButtonProps, noButtonProps, ...restQuickLookProps } = quickLookProps;

  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const handlePopoverOpenChange = (open: boolean) => {
    setPopoverOpen(open);
  };

  return (
    <Popover
      content={
        <QuickLook
          {...restQuickLookProps}
          okButtonProps={{
            ...okButtonProps,
            onClick: (value) => {
              okButtonProps?.onClick?.(value);
              handlePopoverOpenChange(false);
            },
          }}
          noButtonProps={{
            ...noButtonProps,
            onClick: (value) => {
              noButtonProps?.onClick?.(value);
              handlePopoverOpenChange(false);
            },
          }}
        />
      }
      {...popoverProps}
      placement="right"
      onOpenChange={handlePopoverOpenChange}
      overlayStyle={{ zIndex: 1100 }}
      open={popoverOpen && popoverProps?.open}
    >
      {children}
    </Popover>
  );
};

export default QuickLook;
